<template>
    <div class="row flex-grow">
        <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left p-5">
                <div class="brand-logo">
                    <img :src="'/media/aform-logo-green.png'" alt="Coachingclub.lu">
                </div>
                <h4>{{ $t('pages.forgot_password.reset.title') }}</h4>
                <h6 class="font-weight-light" v-html="$t('pages.forgot_password.reset.subtitle')"></h6>
                <div class="pt-3">
                    <div class="input-group">
                        <input type="password" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('password')}" :placeholder="$t('pages.forgot_password.reset.password')" v-model="password"  @keyup.enter="resetPassword">
                        <error input="password"/>
                    </div>
                    <div class="input-group mt-4">
                        <input type="password" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('password_confirmation')}" :placeholder="$t('pages.forgot_password.reset.password_confirm')" v-model="password_confirmation"  @keyup.enter="resetPassword">
                        <error input="password_confirmation"/>
                    </div>
                    <div class="mt3 text-danger mt-1 mb-1" v-if="(password.length < 8 && password.length > 1)">
                        {{ $t('pages.forgot_password.reset.password_length') }}
                    </div>
                    <div class="mt3 text-danger mt-1 mb-1" v-if="(password !== password_confirmation) && password_confirmation.length > 1">
                        {{ $t('pages.forgot_password.reset.password_match') }}
                    </div>
                    <div class="mt-3">
                        <button class="btn btn-block btn-outline-dark btn-lg font-weight-medium auth-form-btn" @click="resetPassword" :disabled="!buttonEnabled" :class="{disabled: !buttonEnabled}">
                            {{ $t('pages.forgot_password.reset.change_password') }}
                        </button>
                    </div>
                    <div class="my-2 d-flex justify-content-between align-items-center">
                        <router-link :to="{name: 'login'}" class="auth-link text-black">
                            {{ $t('pages.forgot_password.login') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthRepository from "../../repositories/Auth/AuthRepository";

export default {
    name: "ResetPassword",
    data: () => ({
        password: '',
        password_confirmation: '',
    }),
    mounted() {
        this.checkPasswordResetToken();
    },
    computed: {
        buttonEnabled() {
            return (this.password.length >= 8 && this.password_confirmation.length >= 8)
                && this.password === this.password_confirmation;
        },
    },
    methods: {
        resetPassword() {
            if(!this.buttonEnabled)
                return false;

            AuthRepository.resetPassword(this.$route.params.token, {
                password: this.password,
                password_confirmation: this.password_confirmation,
            }).then((res) => {
                this.$snotify.success(this.$t('pages.forgot_password.reset.changed'));
                this.$router.push({name: 'login'});
            });
        },

        checkPasswordResetToken() {
            const token = this.$route.params.token;

            AuthRepository.checkPasswordResetToken(token)
                .then((res) => {
                    if(res.data) {
                        if(!res.data.token_check) {
                            this.$snotify.error(this.$t('pages.forgot_password.reset.expired'))
                            //this.$router.push({name: 'login'});
                        }
                    }
                }).catch((err) => {
                this.$router.push({name: 'login'});
            });
        }
    }

}
</script>

<style scoped>

</style>
